import axios from 'Services/axios';

import type { PatchRequest, PatchSellerCommunicationMarkAsContactedResult } from './request';

export type PatchSellerCommunicationMarkAsContactedClientApiCall = (
	data: PatchRequest['body'],
) => Promise<PatchSellerCommunicationMarkAsContactedResult>;

const SELLER_COMMUNICATIONS_MARK_AS_CONTACTED_CLIENT_PATH = '/api/seller-communications/mark-as-contacted';

export const patchSellerCommunicationMarkAsContacted: PatchSellerCommunicationMarkAsContactedClientApiCall = async (
	data,
) => {
	const res = await axios.patch(SELLER_COMMUNICATIONS_MARK_AS_CONTACTED_CLIENT_PATH, data);
	return res.data as ReturnType<PatchSellerCommunicationMarkAsContactedClientApiCall>;
};
